import React from "react";
import classnames from "classnames";
import useStyles from "./FmBox.style";

type variants = "gray" | "orange" | "green" | "red";

interface FmBoxProps {
    children: React.ReactNode;
    variant?: variants;
    className?: string;
}

const FmBox = ({ children, className, variant = "gray" }: FmBoxProps) => {
    const classes = useStyles();

    const containerClass = classnames(classes.fmBox_container, className, {
        [classes.gray]: variant === "gray",
        [classes.orange]: variant === "orange",
        [classes.green]: variant === "green",
        [classes.red]: variant === "red",
    });

    return <div className={containerClass}>{children}</div>;
};

export default FmBox;
